export function refactorLink(link: string | null): string | null {
  if (link && link.length > 0 && !/^https?:\/\//i.test(link)) {
    return "https://" + link;
  }
  return link;
}
